import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { queryClient } from '../src/lib/react-query';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { Auth0ProviderWithNavigate } from './context/AuthProviderWithNavigate';
import { YearsProvider } from './context/YearsContext';
import reportWebVitals from './reportWebVitals';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path='*'
      element={
        <Auth0ProviderWithNavigate>
          <AuthProvider>
            <App />
          </AuthProvider>
        </Auth0ProviderWithNavigate>
      }
    />
  )
);

root.render(
  <QueryClientProvider client={queryClient}>
    <RecoilRoot>
      <YearsProvider>
        <RouterProvider router={router} />
      </YearsProvider>
    </RecoilRoot>
  </QueryClientProvider>
);

reportWebVitals();
